import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerOfferDetailsRoutingModule } from './charter-details-routing.module';
import { CharterDetailsComponent } from './charter-details.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MyChartersCardModule } from '../../shared/my-charters-card/my-charters-card.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AppBuflowMapModule } from '../../shared/app-buyflow-map/app-buyflow-map.module';
import { MainPipe } from '../../shared/pipes/pipes.module';
import { BoatRulesDialogModule } from '../../shared/dialogs/boat-rules-dialog/boat-rules-dialog.module';
import { BuyflowCancellationDialogModule } from '../../shared/dialogs/buyflow-cancellation-dialog/buyflow-cancellation-dialog.module';
import { BuyflowDepositDialogModule } from '../../shared/dialogs/buyflow-deposit-dialog/buyflow-deposit-dialog.module';
import { CustomerAddOnsDialogModule } from '../../shared/dialogs/customer-add-ons-dialog/customer-add-ons-dialog.module';

@NgModule({
  declarations: [CharterDetailsComponent],
  imports: [
    CommonModule,
    CustomerOfferDetailsRoutingModule,
    MatTabsModule,
    MyChartersCardModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    AppBuflowMapModule,
    MainPipe,
    BoatRulesDialogModule,
    BuyflowCancellationDialogModule,
    BuyflowDepositDialogModule,
    CustomerAddOnsDialogModule,
  ],
})
export class CustomerOfferDetailsModule {}
